import { render, staticRenderFns } from "./Oferte.vue?vue&type=template&id=43e18131&scoped=true"
import script from "./Oferte.vue?vue&type=script&lang=js"
export * from "./Oferte.vue?vue&type=script&lang=js"
import style0 from "./Oferte.vue?vue&type=style&index=0&id=43e18131&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e18131",
  null
  
)

export default component.exports